import React from 'react'
import Clickable from 'components/Common/Clickable'
import BodyText from 'components/Luxkit/Typography/BodyText'
import PillLoadingBox from 'components/Luxkit/PillLoadingBox'
import Image from 'components/Common/Image/Image'
import { rem } from 'polished'
import styled from 'styled-components'
import { mediaQueryUp } from 'components/utils/breakpoint'
import Group from 'components/utils/Group'
import PriceRowValueDiscount from 'components/Luxkit/PricePoints/Value/PriceRowValueDiscount'
import LabelGroup from 'components/Luxkit/Label/LabelGroup'

const Section = styled(Clickable)`
  flex-direction: column;
  width: ${rem(160)};

  ${mediaQueryUp.tablet} {
    flex-direction: column;
    width: ${rem(220)};
  }

  &:hover {
    background-color: ${props => props.theme.palette.neutral.default.seven};
  }
`
const OverlayContainer = styled(LabelGroup)`
  position: absolute;
  top: ${rem(8)};
  left: ${rem(8)};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

const StyledGroup = styled(Group)`
  padding-left: ${rem(4)};
  padding-bottom: ${rem(8)};
  padding-right: ${rem(4)};
`

const StyledImage = styled(Image)`
  width: ${rem(160)};
  border-radius: ${props => props.theme.borderRadius.S};

  ${mediaQueryUp.tablet} {
    width: ${rem(220)};
  }
`

const ImageContainer = styled.div`
  position: relative;
  display: inline-block;
`

const ImageOverlay = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to bottom, ${props => props.theme.palette.neutral.default.one} 0%, transparent 30%);
  border-radius: ${props => props.theme.borderRadius.S};
`

interface Props {
  destination: App.DestinationInfo;
  fetchingMaxSavings: boolean;
  savings?: number;
  trackTileClick?: (destination: App.DestinationInfo) => void;
}

function HotelDestinationTile(props: Props) {
  const { destination, savings, fetchingMaxSavings, trackTileClick } = props

  function scrollAndTrack() {
    window.scrollTo({ behavior: 'instant', top: 0 })
    trackTileClick?.(destination)
  }

  return (
    <Section to={destination.url} onClick={scrollAndTrack}>
      <Group direction="vertical" gap={8} horizontalAlign="start">
        <ImageContainer>
          <StyledImage id={destination.imageId} />
          <ImageOverlay/>
          <OverlayContainer>
            {fetchingMaxSavings && <PillLoadingBox width={96} />}
            {!fetchingMaxSavings && !!savings && <PriceRowValueDiscount type="estimate" discountPercentage={savings} />}
          </OverlayContainer>
        </ImageContainer>
        <StyledGroup direction="horizontal" horizontalAlign="center" verticalAlign="center" tabletVerticalAlign="center" gap={4}>
          <BodyText variant="large" weight="bold">{destination.name}</BodyText>
          <BodyText variant="large" weight="normal" colour="neutral-three">({ destination.offersCount })</BodyText>
        </StyledGroup>
      </Group>
    </Section>
  )
}

export default HotelDestinationTile
